import { render, staticRenderFns } from "./DetailSatisfaccionKpi.vue?vue&type=template&id=64fbaad2&"
import script from "./DetailSatisfaccionKpi.vue?vue&type=script&lang=js&"
export * from "./DetailSatisfaccionKpi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports